<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<h2>
    Documents
    <button class="btn--default icon--add" (click)="launchDocumentsModal()" type="button" *ngIf="!hideAddDocuments"> Add Documents</button>
    <button class="btn--default icon--add" (click)="launchAddRequirementsModal()" *ngIf="displayResults && !minimalComponent && !hideAddRequirement" type="button"> Add Requirement</button>
    <button class="btn--default icon--renew" (click)="reset()" type="button" [disabled]="inProgress" *ngIf="!hideFilterOptions"> Reset</button>
    <button class="btn--default icon--remove" type="button" (click)="cancel()" *ngIf="!(minimalComponent || hideCloseButton)"> Close</button>
</h2>
<form [formGroup]="documentForm" autocomplete="off">
    <p-table #dt *ngIf="displayResults" [value]="displayDocuments"
             styleClass="mvd_table--requirements"
             sortField="updateDateDisplayValue" sortOrder="-1" [class.is-active]="classApplied" [paginator]="true"
             [rows]="rows" [lazy]="true" (onLazyLoad)="loadDataLazy($event)" [lazyLoadOnInit]="true"
             [totalRecords]="totalRecords" [columns]="cols">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="10 + (isBusinessTransaction ? 1: 0) + (isDocumentsViewRestricted ? 0: 1) + (hideColumnsForComplianceManagement ? -5: 0)">
                    No Records Found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="caption">
            <div class="row" *ngIf="!hideFilterOptions">
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label>Start Date</label>
                    <p-calendar placeholder="mm/dd/yyyy" [showIcon]="true" dateFormat="mm/dd/yy"
                                formControlName="startDate" (onSelect)="onStartDateChanged($event)"></p-calendar>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="documentForm.hasError('startAfterEndDate')">
                            Start date cannot be after End date
                        </div>
                    </div>
                </div>
                <div class="col-sm-3 col-md-2">
                    <label>End Date</label>
                    <p-calendar placeholder="mm/dd/yyyy" [showIcon]="true" dateFormat="mm/dd/yy"
                                formControlName="endDate" [maxDate]="maxEndDate"></p-calendar>
                </div>
                <div class="col-sm-6 col-md-3">
                    <label>Category</label>
                    <p-dropdown [options]="documentCategoryTypes" formControlName="categoryTypeId"
                                filter="filter"></p-dropdown>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-3">
                    <label>Requirement</label>
                    <p-dropdown [options]="documentTypes" formControlName="documentTypeId"
                                filter="filter"></p-dropdown>
                </div>
                <div class="col-sm-1 text-left">
                    <button class="btn--primary" style="margin-top:18px;" type="submit" (click)="search()" [disabled]="inProgress">Find</button>
                </div>
                <div class="col-sm-5 col-md-12 col-lg-1 text-right">
                    <label>&nbsp;</label>
                    <a class="mvd_table__toggle-2" href="javascript:void(0)" (click)="toggleClass()"></a>
                </div>
            </div>

            <div class="row" *ngIf="isBusinessTransaction">
                <div class="col-sm-9">
                    <label for="scanLater" class="mvd_label--inline">
                        <input id="scanLater" name="scanLater" type="checkbox" formControlName="IsScanLater"
                               (change)="updateScanLaterAll($event)" /> Scan Later
                    </label>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="w--icon" [pSortableColumn]="'documentTypeRequirementsSatisfied'" *ngIf="!hideColumnsForComplianceManagement">
                    Status<p-sortIcon [field]="'documentTypeRequirementsSatisfied'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'documentCategoryType'">
                    Categ<p-sortIcon [field]="'documentCategoryType'">
                    </p-sortIcon>
                </th>
                <th [pSortableColumn]="'documentType'">
                    Reqmt<p-sortIcon [field]="'documentType'"></p-sortIcon>
                </th>
                <th>File</th>
                <th [pSortableColumn]="'notificationComment'">
                    Comnt<p-sortIcon [field]="'notificationComment'"></p-sortIcon>
                </th>
                <th *ngIf="!hideColumnsForComplianceManagement">Desc</th>
                <th *ngIf="!hideColumnsForComplianceManagement">Comnt</th>
                <th class="w--date" [pSortableColumn]="'updateDateDisplayValue'">
                    Updated<p-sortIcon [field]="'updateDateDisplayValue'"></p-sortIcon>
                </th>
                <th *ngIf="!hideColumnsForComplianceManagement || !canSelectSignedDocuments">Sig</th>
                <th *ngIf="isBusinessTransaction">Scan Later</th>
                <th class="w--status" *ngIf="!hideColumnsForComplianceManagement && !isViewOnly">Review Status</th>
                <th class="w--actions-4" *ngIf="!isDocumentsViewRestricted">Actions</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
            <ng-container formGroupName="documents">
                <tr [formGroupName]="rowData.documentId">
                    <td *ngIf="!hideColumnsForComplianceManagement">
                        <div class="text-center" title="Unsatisfied" *ngIf="rowData.documentTypeRequirementsSatisfied == false">
                            <i class="material-icons status--unsatisfied">error</i>
                        </div>
                        <div class="text-center" title="Satisfied" *ngIf="rowData.documentTypeRequirementsSatisfied == true">
                            <i class="material-icons status--satisfied">check_circle</i>
                        </div>
                    </td>
                    <td class="td--hover-show">{{rowData.documentCategoryType}}</td>
                    <td class="td--hover-show">{{rowData.documentType}}</td>
                    <td class="td--hover-show">{{rowData.documentFilename}}</td>
                    <td class="td--hover-show">
                        <span class="text-center" *ngIf="rowData.loading">
                            <i class="fa fa-spinner fa-spin fa-fw fa-2x"
                               style="color:gray;"></i>
                        </span>
                        <label *ngIf="!rowData.loading && (isDocumentsViewRestricted || rowData.isDocumentsViewRestricted)">{{rowData.documentFilename}}</label>
                        <a href="javascript:void(0)"
                           *ngIf="!rowData.loading && !isDocumentsViewRestricted && !rowData.isDocumentsViewRestricted"
                           title="Download Document File"
                           (click)="downloadDocument(rowData)">{{rowData.documentFilename}}</a>
                    </td>
                    <td class="td--hover-show" *ngIf="!hideColumnsForComplianceManagement">
                        {{rowData.documentDescription}}
                    </td>
                    <td class="td--hover-show" *ngIf="!hideColumnsForComplianceManagement">
                        {{rowData.notificationComment}}
                    </td>
                    <td>{{rowData.updateDateDisplayValue}}</td>
                    <td *ngIf="!hideColumnsForComplianceManagement || !canSelectSignedDocuments">
                        {{rowData.documentSignatureStatusTypeDisplayValue}}
                        <a href="javascript:void(0)" class="icon--add" title="Add Invitation" *ngIf="canSelectSignedDocuments && showAddInvitation(rowData)"
                           (click)="createInvitation(rowData)"></a>
                        <ng-container *ngIf="canSelectSignedDocuments && showInvitationToken(rowData)">
                            - {{rowData.assistedSelfServiceInvitationToken}}
                        </ng-container>
                    </td>
                    <td *ngIf="isBusinessTransaction && !hideColumnsForComplianceManagement">
                        <select class="mvd_form-control" formControlName="documentReviewStatusTypeId"
                                id="documentReviewStatusTypeId{{rowData.documentId}}"
                                (change)="updateDocumentReviewStatus($event.target.value, rowData)"
                                *ngIf="rowData.documentId > 0">
                            <option *ngFor="let documentReviewStatusType of documentReviewStatusTypes"
                                    value="{{documentReviewStatusType.value}}">
                                {{documentReviewStatusType.label}}
                            </option>
                        </select>
                    </td>
                    <td *ngIf="!hideColumnsForComplianceManagement && !isViewOnly">
                        <select class="mvd_form-control" formControlName="documentReviewStatusTypeId"
                                id="documentReviewStatusTypeId{{rowData.documentId}}"
                                (change)="updateDocumentReviewStatus($event.target.value, rowData)"
                                *ngIf="rowData.documentId > 0">
                            <option *ngFor="let documentReviewStatusType of documentReviewStatusTypes"
                                    value="{{documentReviewStatusType.value}}">
                                {{documentReviewStatusType.label}}
                            </option>
                        </select>
                    </td>
                    <td *ngIf="!isDocumentsViewRestricted">
                        <a href="javascript:void(0)" class="icon--edit" title="Edit Document"
                           [ngClass]="{invisible: rowData.documentId == 0}"
                           *ngIf="!rowData.loading && !rowData.isDocumentsViewRestricted && !isSelectOnly && !isViewOnly"
                           (click)="addDocumentRequirementToDocument(rowData.documentId, rowData.documentFilename)"
                           data-bs-toggle="tooltip"></a>
                        <a href="javascript:void(0)" class="icon--download" title="Download Document"
                           *ngIf="!rowData.loading && !rowData.isDocumentsViewRestricted && !isSelectOnly"
                           (click)="downloadDocument(rowData)"></a>
                        <a href="javascript:void(0)" class="icon--delete" title="Delete Document"
                           [ngClass]="{invisible: rowData.documentRequirementTypeId == 1}"
                           *ngIf="(!rowData.loading && !rowData.isDocumentsViewRestricted && !isSelectOnly) && rowData.isAllowDeleteScannedDocuments" tabindex="-1"
                           (click)="delete(rowData)"></a>
                        <a href="javascript:void(0)" class="icon--add" title="Add Document"
                           [ngClass]="{invisible: rowData.documentId > 0}" *ngIf="!isSelectOnly"
                           (click)="addDocumentToDocumentRequirement(rowData.documentCategoryTypeId, rowData.documentTypeId, rowData.documentRequirementTypeId)"></a>
                        <a href="javascript:void(0)" class="icon--select" title="Select Document"
                           [ngClass]="{invisible: rowData.documentId == 0 || unselectableDocumentTypeIds.includes(+rowData.documentTypeId), disabled: (!canSelectSignedDocuments && rowData.documentSignatureStatusTypeId === documentSignatureStatusType.SigningComplete.id) || selectInProgress}"
                           *ngIf="isSelectOnly" (click)="selectDocument(rowData.documentId)"></a>
                    </td>
                </tr>
            </ng-container>
        </ng-template>
    </p-table>
</form>
